import Vue from 'vue'
import Router from 'vue-router'
import {
  Modal,
  DatePicker,
  Table,
  message
} from 'ant-design-vue';

Vue.use(Router)



// 解决$router.push()报错问题
// 获取原型对象上的push函数
const originalPush = Router.prototype.push
// 修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

var sUserAgent = navigator.userAgent.toLowerCase()
const equipment = /ipad|iphone|midp|rv:1.2.3.4|ucweb|android|windows ce|windows mobile/.test(sUserAgent)

const layout = r => require.ensure([], () => r(require('@/views/Layout/M_Layout')), 'layout')
const Login = r => require.ensure([], () => r(equipment ? require('@/views/phoneLogin') : require('@/views/Login1')), 'login')
const phoneSettingPass = r => require.ensure([], () => r(require('@/components/phone_settingPassword')), 'phoneSettingPass')
const channelPage = r => require.ensure([], () => r(require('@/views/ChannelPage/index')), 'channelPage')
const analysisReportDetail = r => require.ensure([], () => r(require('@/components/analysisReportDetail')), 'analysisReportDetail')
const officeDocView = r => require.ensure([], () => r(require('@/components/OfficePreview/officeDocView')), 'officeDocView')
const officePdfView = r => require.ensure([], () => r(require('@/components/OfficePreview/officePdfView')), 'officePdfView')
const officePdfView4 = r => require.ensure([], () => r(require('@/components/OfficePreview/officePdfView4')), 'officePdfView4')
const KolTracking = r => require.ensure([], () => r(require('@/views/KolTracking/index')), 'KolTracking')
const kolTrackingDashboard = r => require.ensure([], () => r(require('@/views/KolTracking/dashboard')), 'kolTrackingDashboard')
const viewFileNewPage = r => require.ensure([], () => r(require('@/views/KolTracking/compotent/viewFileNewPage')), 'viewFileNewPage')
const kolTrackSettingProduct = r => require.ensure([], () => r(require('@/views/KolTracking/settingProduct')), 'kolTrackSettingProduct')
const prictice = r => require.ensure([], () => r(require('@/views/KolTracking/prictice')), 'prictice')

const kolTrackSettingMarketing = r => require.ensure([], () => r(require('@/views/KolTracking/settingMarketing')), 'kolTrackSettingMarketing')



const Home = r => require.ensure([], () => r(require('@/views/Home/home')), 'Home')
const KolMkt = r => require.ensure([], () => r(require('@/views/Kolmkt/index')), 'kolMkt')
const cpsMain = r => require.ensure([], () => r(require('@/views/Cps/cpsMain')), 'cpsMain')
const localMedia = r => require.ensure([], () => r(require('@/views/LocalMedia/index')), 'localMedia')
const localDashboard = r => require.ensure([], () => r(require('@/views/LocalMedia/dashboard')), 'localDashboard')
const localReport = r => require.ensure([], () => r(require('@/views/LocalMedia/report')), 'localReport')
const localCreatives = r => require.ensure([], () => r(require('@/views/LocalMedia/creatives')), 'localCreatives')
const localAnalysis = r => require.ensure([], () => r(require('@/views/LocalMedia/analysis')), 'localAnalysis')
// const localSetting = r => require.ensure([], () => r(require('@/views/LocalMedia/Setting/setting')), 'localSetting')
/* localSetting */
const localSettingBasicData = r => require.ensure([], () => r(require('@/views/LocalMedia/Setting/setting')), 'localSettingBasicData')
const localSettingCreatives = r => require.ensure([], () => r(require('@/views/LocalMedia/Setting/creatives')), 'localSettingCreatives')
const localSettingAnayltics = r => require.ensure([], () => r(require('@/views/LocalMedia/Setting/anayltics')), 'localSettingAnayltics')

/**
 * Local Retargeting
 */
const localRetargeting = r => require.ensure([], () => r(require('@/views/LocalRetarting/index')), 'localRetargeting')
const localRetargetingDashboard = r => require.ensure([], () => r(require('@/views/LocalRetarting/dashboard')), 'localRetargetingDashboard')
const localRetargetingReport = r => require.ensure([], () => r(require('@/views/LocalRetarting/report')), 'localRetargetingReport')
const localRetargetingCreatives = r => require.ensure([], () => r(require('@/views/LocalRetarting/creatives')), 'localRetargetingCreatives')
const localRetargetingAnalysis = r => require.ensure([], () => r(require('@/views/LocalRetarting/analysis')), 'localRetargetingAnalysis')
const localRetargetingSettingBasicData = r => require.ensure([], () => r(require('@/views/LocalRetarting/Setting/setting')), 'localRetargetingSettingBasicData')
const localRetargetingSettingCreatives = r => require.ensure([], () => r(require('@/views/LocalRetarting/Setting/creatives')), 'localRetargetingSettingCreatives')
const localRetargetingSettingAnayltics = r => require.ensure([], () => r(require('@/views/LocalRetarting/Setting/anayltics')), 'localRetargetingSettingAnayltics')

/**
 * 梯媒
 */
const localMediaLift = r => require.ensure([], () => r(require('@/views/localMediaLift/index')), 'localMediaLift')
const localMediaLiftDashboard = r => require.ensure([], () => r(require('@/views/localMediaLift/dashboard')), 'localMediaLiftDashboard')
const localMediaLiftReport = r => require.ensure([], () => r(require('@/views/localMediaLift/report')), 'localMediaLiftReport')
const localLiftReportDetail = r => require.ensure([], () => r(require('@/views/localMediaLift/reportDetail')), 'localLiftReportDetail')
const localMediaLiftSetting = r => require.ensure([], () => r(require('@/views/localMediaLift/setting')), 'localMediaLiftSetting')
const localMediaLiftSettingMain = r => require.ensure([], () => r(require('@/views/localMediaLift/settingMain')), 'localMediaLiftSettingMain')
const localMediaLiftSettingAddCampaignInfo = r => require.ensure([], () => r(require('@/views/localMediaLift/settingAddCampaignInfo')), 'localMediaLiftSettingAddCampaignInfo')

const AgglocalMedia = r => require.ensure([], () => r(require('@/views/Aggregator/index')), 'agglocalMedia')
const AgglocalDashboard = r => require.ensure([], () => r(require('@/views/Aggregator/dashboard')), 'agglocalDashboard')
const AgglocalReport = r => require.ensure([], () => r(require('@/views/Aggregator/report')), 'agglocalReport')
const AgglocalCreatives = r => require.ensure([], () => r(require('@/views/Aggregator/creatives')), 'agglocalCreatives')
const AgglocalAnalysis = r => require.ensure([], () => r(require('@/views/Aggregator/analysis')), 'agglocalAnalysis')
// const localSetting = r => require.ensure([], () => r(require('@/views/Aggregator/Setting/setting')), 'agglocalSetting')
/* localSetting */
const AgglocalSettingBasicData = r => require.ensure([], () => r(require('@/views/Aggregator/Setting/setting')), 'agglocalSettingBasicData')
const AgglocalSettingCreatives = r => require.ensure([], () => r(require('@/views/Aggregator/Setting/creatives')), 'agglocalSettingCreatives')
const AgglocalSettingAnayltics = r => require.ensure([], () => r(require('@/views/Aggregator/Setting/anayltics')), 'agglocalSettingAnayltics')

const ProlocalMedia = r => require.ensure([], () => r(require('@/views/ProgrammaticUser/index')), 'prolocalMedia')
const ProlocalDashboard = r => require.ensure([], () => r(require('@/views/ProgrammaticUser/dashboard')), 'prolocalDashboard')
const ProlocalReport = r => require.ensure([], () => r(require('@/views/ProgrammaticUser/report')), 'prolocalReport')
const ProlocalCreatives = r => require.ensure([], () => r(require('@/views/ProgrammaticUser/creatives')), 'prolocalCreatives')
const ProlocalAnalysis = r => require.ensure([], () => r(require('@/views/ProgrammaticUser/analysis')), 'prolocalAnalysis')

// 程序化网盟数据
const programmaticManage = r => require.ensure([], () => r(require('@/views/ProgrammaticManageUser/index')), 'prolocalMedia')
const programmaticManageDashboard = r => require.ensure([], () => r(require('@/views/ProgrammaticManageUser/dashboard')), 'programmaticManageDashboard')
const programmaticManageReport = r => require.ensure([], () => r(require('@/views/ProgrammaticManageUser/report')), 'programmaticManageReport')
const programmaticManageSetting = r => require.ensure([], () => r(require('@/views/ProgrammaticManageUser/setting')), 'programmaticManageSetting')

// const localSetting = r => require.ensure([], () => r(require('@/views/Aggregator/Setting/setting')), 'prolocalSetting')
/* localSetting */
const ProlocalSettingBasicData = r => require.ensure([], () => r(require('@/views/ProgrammaticUser/Setting/setting')), 'prolocalSettingBasicData')
const ProlocalSettingCreatives = r => require.ensure([], () => r(require('@/views/ProgrammaticUser/Setting/creatives')), 'prolocalSettingCreatives')
const ProlocalSettingAnayltics = r => require.ensure([], () => r(require('@/views/ProgrammaticUser/Setting/anayltics')), 'prolocalSettingAnayltics')


const AdnlocalMedia = r => require.ensure([], () => r(require('@/views/AdnUser/index')), 'adnlocalMedia')
const AdnlocalDashboard = r => require.ensure([], () => r(require('@/views/AdnUser/dashboard')), 'adnlocalDashboard')
const AdnlocalReport = r => require.ensure([], () => r(require('@/views/AdnUser/report')), 'adnlocalReport')
const AdnlocalCreatives = r => require.ensure([], () => r(require('@/views/AdnUser/creatives')), 'adnlocalCreatives')
const AdnlocalAnalysis = r => require.ensure([], () => r(require('@/views/AdnUser/analysis')), 'adnlocalAnalysis')
// const localSetting = r => require.ensure([], () => r(require('@/views/Aggregator/Setting/setting')), 'prolocalSetting')
/* localSetting */
const AdnlocalSettingBasicData = r => require.ensure([], () => r(require('@/views/AdnUser/Setting/setting')), 'adnlocalSettingBasicData')
const AdnlocalSettingCreatives = r => require.ensure([], () => r(require('@/views/AdnUser/Setting/creatives')), 'adnlocalSettingCreatives')
const AdnlocalSettingAnayltics = r => require.ensure([], () => r(require('@/views/AdnUser/Setting/anayltics')), 'adnlocalSettingAnayltics')


const Dashboard = r => require.ensure([], () => r(require('@/views/Cps/dashboard')), 'Dashboard')
const Report = r => require.ensure([], () => r(require('@/views/Cps/report')), 'Report')
const Creative = r => require.ensure([], () => r(require('@/views/Cps/creative')), 'Creative')
const Setting = r => require.ensure([], () => r(require('@/views/Cps/Setting/settingList')), 'settingList')

const Authority =  r => require.ensure([], () => r(require('@/views/Authority/index')), 'Authority')
const Userhome =  r => require.ensure([], () => r(require('@/views/Userhome/index.vue')), 'Userhome')
const NoAuthority =  r => require.ensure([], () => r(require('@/views/NoAuthority/index.vue')), 'NoAuthority')
const UserAuth =  r => require.ensure([], () => r(require('@/views/Authority/userAuth')), 'UserAuth')
const SubscriptionSetting =  r => require.ensure([], () => r(require('@/views/Authority/SubscriptionSetting')), 'SubscriptionSetting')

const BisicSetting =  r => require.ensure([], () => r(require('@/views/Authority/BisicSetting')), 'BisicSetting')
const CustomerProduct =  r => require.ensure([], () => r(require('@/views/Authority/CustomerProduct')), 'CustomerProduct')
const CustomerAccount =  r => require.ensure([], () => r(require('@/views/Authority/CustomerAccount')), 'CustomerAccount')
const Rdtools =  r => require.ensure([], () => r(require('@/views/Authority/Rdtools')), 'Rdtools')

const RdtoolsApiauth =  r => require.ensure([], () => r(require('@/views/Authority/RdtoolsApiAuth')), 'RdtoolsApiauth')
const RdtoolsMenuauth =  r => require.ensure([], () => r(require('@/views/Authority/RdtoolsMenuAuth')), 'RdtoolsMenuauth')
const MediaSource =  r => require.ensure([], () => r(require('@/views/Authority/mediaSource')), 'MediaSource')
const publicReources =  r => require.ensure([], () => r(require('@/views/Authority/publicResources')), 'publicReources')
const whatsnewSetting =  r => require.ensure([], () => r(require('@/views/Authority/whatsnewSetting')), 'whatsnewSetting')
const whatsnewSetting2 =  r => require.ensure([], () => r(require('@/views/Authority/whatsnewSetting2')), 'whatsnewSetting2')
const Account =  r => require.ensure([], () => r(require('@/views/Authority/account')), 'account')
const Mypassword =  r => require.ensure([], () => r(require('@/views/Authority/myPassword')), 'Mypassword')
const HelpCenterSetteing = r => require.ensure([], () => r(require('@/views/Authority/HelpCenterSetteing')), 'HelpCenterSetteing')
const AccountAuthority = r => require.ensure([], () => r(require('@/views/Authority/AccountAuthority')), 'AccountAuthority')
const ClientAccountSetting = r => require.ensure([], () => r(require('@/views/Authority/ClientAccountSetting')), 'ClientAccountSetting')
const BusinessAuthoritySetting = r => require.ensure([], () => r(require('@/views/Authority/BusinessAuthoritySetting')), 'BusinessAuthoritySetting')

// kol mkt
const kolDashboard = r => require.ensure([], () => r(require('@/views/Kolmkt/dashboard')), 'kolDashboard')
const kolReport = r => require.ensure([], () => r(require('@/views/Kolmkt/report')), 'kolReport')
const kolReportResult = r => require.ensure([], () => r(require('@/views/Kolmkt/reportResult')), 'kolReportResult')

const kolMktSettingBasicData = r => require.ensure([], () => r(require('@/views/Kolmkt/setting/basicData')), 'kolMktSettingBasicData')
const kolMktSettingReportResult = r => require.ensure([], () => r(require('@/views/Kolmkt/setting/reportResult')), 'kolMktSettingReportResult')
const kolMktSettingKolUpload = r => require.ensure([], () => r(require('@/views/Kolmkt/setting/kolUpload')), 'kolMktSettingKolUpload')
// const kolSetting = r => require.ensure([], () => r(require('@/views/Kolmkt/setting')), 'kolSetting')

const ProgrammaticRetarting = r => require.ensure([], () => r(require('@/views/ProgrammaticRetarting/index')), 'ProgrammaticRetarting')
const ProgrammaticRetartingDashboard = r => require.ensure([], () => r(require('@/views/ProgrammaticRetarting/dashboard')), 'ProgrammaticRetartingDashboard')
const ProgrammaticRetartingReport = r => require.ensure([], () => r(require('@/views/ProgrammaticRetarting/report')), 'ProgrammaticRetartingReport')
const ProgrammaticRetartingCreatives = r => require.ensure([], () => r(require('@/views/ProgrammaticRetarting/creatives')), 'ProgrammaticRetartingCreatives')
const ProgrammaticRetartingAnalysis = r => require.ensure([], () => r(require('@/views/ProgrammaticRetarting/analysis')), 'ProgrammaticRetartingAnalysis')
const ProgrammaticRetartingSettingBasicData = r => require.ensure([], () => r(require('@/views/ProgrammaticRetarting/Setting/setting')), 'ProgrammaticRetartingSettingBasicData')
const ProgrammaticRetartingSettingCreatives = r => require.ensure([], () => r(require('@/views/ProgrammaticRetarting/Setting/creatives')), 'ProgrammaticRetartingSettingCreatives')
const ProgrammaticRetartingSettingAnayltics = r => require.ensure([], () => r(require('@/views/ProgrammaticRetarting/Setting/anayltics')), 'ProgrammaticRetartingSettingAnayltics')
// kol search
const KolSearch = r => require.ensure([], () => r(require('@/views/KolSearch/index')), 'KolSearch')
// Resources
const DetailPage = r => require.ensure([], () => r(require('@/views/KolSearch/detailPage')), 'DetailPage')
const TiktokDetailPage = r => require.ensure([], () => r(require('@/views/KolSearch/tiktokDetailPage')), 'TiktokDetailPage')
const InsDetailPage = r => require.ensure([], () => r(require('@/views/KolSearch/insDetailPage')), 'InsDetailPage')
const CollectionPage = r => require.ensure([], () => r(require('@/views/KolSearch/collectionPage')), 'CollectionPage')
const KolFolderPage = r => require.ensure([], () => r(require('@/views/KolSearch/kolFolderPage')), 'KolFolderPage')
const Resources = r => require.ensure([], () => r(require('@/views/Resources/index')), 'Resources')
const Marketreports = r => require.ensure([], () => r(require('@/views/Resources/marketReports')), 'Marketreports')
const Appanalysis = r => require.ensure([], () => r(require('@/views/Resources/appAnalysis')), 'Appanalysis')
const Competitoranalysis = r => require.ensure([], () => r(require('@/views/Resources/competitorAnalysis')), 'Competitoranalysis')
const AppDataMarket = r => require.ensure([], () => r(require('@/views/Resources/appDataMarket')), 'AppDataMarket')

const Programmatic = r => require.ensure([], () => r(require('@/views/Programmatic/index')), 'Programmatic')

// Whatsnew
const Whatsnew = r => require.ensure([], () => r(require('@/views/Whatsnew/index')), 'Whatsnew')
//HelpCenter
const HelpCenter = r => require.ensure([], () => r(require('@/views/HelpCenter/index')), 'HelpCenter')

//AppDataMarket new
const newAppDataMarket = r => require.ensure([], () => r(require('@/views/newResource/appDataMarket')), 'newAppDataMarket')
const appAnalysisReports = r => require.ensure([], () => r(require('@/views/newResource/appAnalysisReports')), 'appAnalysisReports')
const marketAnalysisReports = r => require.ensure([], () => r(require('@/views/newResource/marketAnalysisReports')), 'marketAnalysisReports')
//HelpCenterView
const HelpCenterView = r => require.ensure([], () => r(require('@/views/HelpCenter/helpCenterView')), 'HelpCenterView')
// notifications
const Notifications = r => require.ensure([], () => r(require('@/views/Notifications/index')), 'Notifications')
const routers = new Router({
  routes: [
    {
      path: '/',
      redirect: '/login',
    },
    {
      path: '*',
      redirect: '/login',
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/phoneSettingPass',
      name: 'phoneSettingPass',
      component: phoneSettingPass
    },
    {
      path: '/channelPage',
      name: 'channelPage',
      component: channelPage
    },
    {
      path: '/analysisReportDetail',
      name: 'analysisReportDetail',
      component: analysisReportDetail
    },
    {
      path: '/officeDocView',
      name: 'officeDocView',
      component: officeDocView
    },
    {
      path: '/officePdfView',
      name: 'officePdfView',
      component: officePdfView
    },
    {
      path: '/officePdfView4',
      name: 'officePdfView4',
      component: officePdfView4
    },
    {
      path: '/layout',
      name: '',
      component: layout,
      redirect: '/home',
      children: [
        {
          path: '/home',
          name: 'home',
          component: Home
        },
        {
          path: '/kolMkt',
          name: 'kolMkt',
          component: KolMkt,
          redirect: '/kolMkt/dashboard',
          children: [
            {
              path: '/kolMkt/dashboard',
              name: 'kolDashboard',
              component: kolDashboard,
              meta: {
                belongName:['kolMkt'],
                alias:'KOL MKT'
              },
            },
            {
              path: '/kolMkt/report',
              name: 'kolReport',
              component: kolReport,
              meta: {
                belongName:['kolMkt'],
                alias:'KOL MKT'
              },
            },
            {
              path: '/kolMkt/reportResult',
              name: 'kolReportResult',
              component: kolReportResult,
              meta: {
                belongName:['kolMkt'],
                alias:'KOL MKT'
              },
            },
            {
              path: '/kolMkt/setting/basicData',
              name: 'kolMktSettingBasicData',
              component: kolMktSettingBasicData,
              meta: {
                belongName:['kolMkt'],
                alias:'KOL MKT'
              }
            },
            {
              path: '/kolMkt/setting/reportResult',
              name: 'kolMktSettingReportResult',
              component: kolMktSettingReportResult,
              meta: {
                belongName:['kolMkt'],
                alias:'KOL MKT'
              }
            },
            {
              path: '/kolMkt/setting/kolUpload',
              name: 'kolMktSettingKolUpload',
              component: kolMktSettingKolUpload,
              meta: {
                belongName:['kolMkt'],
                alias:'KOL MKT'
              }
            },
            // {
            //   path: '/kolMkt/setting',
            //   name: 'kolSetting',
            //   component: kolSetting,
            //   meta: {
            //     belongName:['kolMkt'],
            //     noEnterRoreId: ['12'],
            //     defaultPath: '/kolMkt/dashboard',
            //     alias:'KOL MKT'
            //   },
            // }
          ]
        },
        {
          path: '/kolTracking',
          name: 'kolTracking',
          component: KolTracking,
          redirect: '/kolTracking/kolTrackingDashboard',
          children: [
            {
              path: '/kolTracking/kolTrackingDashboard',
              name: 'kolTrackingDashboard',
              component: kolTrackingDashboard,
              meta: {
                belongName:['kolMkt'],
                alias:'Kol Tracking'
              },
            },
            {
              path: '/kolTracking/compotent/viewFileNewPage',
              name: 'viewFileNewPage',
              component: viewFileNewPage,
              meta: {
                belongName:['kolMkt'],
                alias:'Kol Tracking'
              },
            },
            {
              path: '/kolTracking/setting/product',
              name: 'kolTrackSettingProduct',
              component: kolTrackSettingProduct,
              meta: {
                belongName:['kolMkt'],
                alias:'Kol Tracking'
              }
            },
            {
              path: '/kolTracking/setting/prictice',
              name: 'prictice',
              component: prictice,
              meta: {
                belongName:['kolMkt'],
                alias:'Kol Tracking'
              }
            },
            {
              path: '/kolTracking/setting/marketing',
              name: 'kolTrackSettingMarketing',
              component: kolTrackSettingMarketing,
              meta: {
                belongName:['kolMkt'],
                alias:'Kol Tracking'
              }
            },
            // {
            //   path: '/kolMkt/report',
            //   name: 'kolReport',
            //   component: kolReport,
            //   meta: {
            //     belongName:['kolMkt'],
            //     alias:'KOL MKT'
            //   },
            // },
            // {
            //   path: '/kolMkt/reportResult',
            //   name: 'kolReportResult',
            //   component: kolReportResult,
            //   meta: {
            //     belongName:['kolMkt'],
            //     alias:'KOL MKT'
            //   },
            // },
         
            // {
            //   path: '/kolMkt/setting/reportResult',
            //   name: 'kolMktSettingReportResult',
            //   component: kolMktSettingReportResult,
            //   meta: {
            //     belongName:['kolMkt'],
            //     alias:'KOL MKT'
            //   }
            // },

          ]
        },
        {
          path: '/aggregator',
          name: 'aggregator',
          component: cpsMain,
          redirect: '/aggregator/dashboard',
          children: [
            {
              path: '/aggregator/dashboard',
              name: 'dashboard',
              component: Dashboard,
              meta: {
                belongName:['aggregator'],
                alias:'CPS'
              },
            },
            {
              path: '/aggregator/report',
              name: 'cpsReport',
              component: Report,
              meta: {
                belongName:['aggregator'],
                alias:'CPS'
              },
            },
            {
              path: '/aggregator/creative',
              name: 'creative',
              component: Creative,
              meta: {
                belongName:['aggregator'],
                alias:'CPS'
              },
            },
            {
              path: '/aggregator/setting',
              name: 'setting',
              component: Setting,
              meta: {
                belongName:['aggregator'],
                noEnterRoreId: ['12'],
                defaultPath: '/aggregator/dashboard',
                alias:'CPS'
              },
            }
          ]
        },
        {
          path: '/localMedia',
          name: 'localMedia',
          component: localMedia,
          redirect: '/localMedia/dashboard',
          children: [
            {
              path: '/localMedia/dashboard',
              name: 'localDashboard',
              component: localDashboard,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            },
            {
              path: '/localMedia/report',
              name: 'localreport',
              component: localReport,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            },
            {
              path: '/localMedia/creatives',
              name: 'localCreatives',
              component: localCreatives,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            },
            {
              path: '/localMedia/analysis',
              name: 'localAnalysis',
              component: localAnalysis,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            },
            {
              path: '/localMedia/setting/basicData',
              name: 'localSettingBasicData',
              component: localSettingBasicData,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media',
                noEnterRoreId: ['12'],
              }
            },
            {
              path: '/localMedia/setting/creatives',
              name: 'localSettingCreatives',
              component: localSettingCreatives,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media',
                noEnterRoreId: ['12'],
              }
            },
            {
              path: '/localMedia/setting/anayltics',
              name: 'localSettingAnayltics',
              component: localSettingAnayltics,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media',
                noEnterRoreId: ['12'],
              }
            },
            // {
            //   path: '/localMedia/setting',
            //   name: 'localSetting',
            //   // component: localSetting,
            //   meta: {
            //     belongName:['localMedia'],
            //     noEnterRoreId: ['12'],
            //     defaultPath: '/localMedia/dashboard',
            //     alias:'Local Media'
            //   },
            // }
          ]
        },
        {
          path: '/localRetargeting',
          name: 'localRetargeting',
          component: localRetargeting,
          redirect: '/localRetargeting/dashboard',
          children: [
            {
              path: '/localRetargeting/dashboard',
              name: 'localRetargetingDashboard',
              component: localRetargetingDashboard,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            },
            {
              path: '/localRetargeting/report',
              name: 'localRetargetingReport',
              component: localRetargetingReport,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            },
            {
              path: '/localRetargeting/creatives',
              name: 'localRetargetingCreatives',
              component: localRetargetingCreatives,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            },
            {
              path: '/localRetargeting/analysis',
              name: 'localRetargetingAnalysis',
              component: localRetargetingAnalysis,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            },
            {
              path: '/localRetargeting/setting/basicData',
              name: 'localRetargetingSettingBasicData',
              component: localRetargetingSettingBasicData,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media',
                noEnterRoreId: ['12'],
              }
            },
            {
              path: '/localRetargeting/setting/creatives',
              name: 'localRetargetingSettingCreatives',
              component: localRetargetingSettingCreatives,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media',
                noEnterRoreId: ['12'],
              }
            },
            {
              path: '/localRetargeting/setting/anayltics',
              name: 'localRetargetingSettingAnayltics',
              component: localRetargetingSettingAnayltics,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media',
                noEnterRoreId: ['12'],
              }
            },
          ]
        },
        {
          path: '/localMediaLift',
          name: 'localMediaLift',
          component: localMediaLift,
          redirect: '/localMediaLift/dashboard',
          children: [
            {
              path: '/localMediaLift/dashboard',
              name: 'localMediaLiftDashboard',
              component: localMediaLiftDashboard,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            },
            {
              path: '/localMediaLift/report',
              name: 'localMediaLiftReport',
              component: localMediaLiftReport,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              },
            },
            {
              path: '/localMediaLift/setting',
              name: 'localMediaLiftSetting',
              component: localMediaLiftSetting,
              redirect: '/localMediaLift/setting/main',
              children: [
                {
                  path: '/localMediaLift/setting/main',
                  name: 'localMediaLiftSettingMain',
                  component: localMediaLiftSettingMain,
                  meta: {
                    belongName:['localMedia'],
                    alias:'Local Media'
                  },
                },
                {
                  path: '/localMediaLift/setting/addCampaignInfo',
                  name: 'localMediaLiftSettingAddCampaignInfo',
                  component: localMediaLiftSettingAddCampaignInfo,
                  meta: {
                    belongName:['localMedia'],
                    alias:'Local Media'
                  },
                },
              ],
            },
            {
              path: '/localMediaLift/localLiftReportDetail',
              name: 'localLiftReportDetail',
              component: localLiftReportDetail,
              meta: {
                belongName:['localMedia'],
                alias:'Local Media'
              }
            }
          ]
        },
        {
          path: '/agglocalMedia',
          name: 'agglocalMedia',
          component: AgglocalMedia,
          redirect: '/agglocalMedia/dashboard',
          children: [
            {
              path: '/agglocalMedia/dashboard',
              name: 'agglocalDashboard',
              component: AgglocalDashboard,
              meta: {
                belongName:['aggregator'],
                alias:'Agg Local Media'
              }
            },
            {
              path: '/agglocalMedia/report',
              name: 'agglocalreport',
              component: AgglocalReport,
              meta: {
                belongName:['aggregator'],
                alias:'Agg Local Media'
              }
            },
            {
              path: '/agglocalMedia/creatives',
              name: 'agglocalCreatives',
              component: AgglocalCreatives,
              meta: {
                belongName:['aggregator'],
                alias:'Agg Local Media'
              }
            },
            {
              path: '/agglocalMedia/analysis',
              name: 'agglocalAnalysis',
              component: AgglocalAnalysis,
              meta: {
                belongName:['aggregator'],
                alias:'Agg Local Media'
              }
            },
            {
              path: '/agglocalMedia/setting/basicData',
              name: 'agglocalSettingBasicData',
              component: AgglocalSettingBasicData,
              meta: {
                belongName:['aggregator'],
                alias:'Agg Local Media',
                noEnterRoreId: ['12'],
              }
            },
            {
              path: '/agglocalMedia/setting/creatives',
              name: 'agglocalSettingCreatives',
              component: AgglocalSettingCreatives,
              meta: {
                belongName:['aggregator'],
                noEnterRoreId: ['12'],
                alias:'Agg Local Media'
              }
            },
            {
              path: '/agglocalMedia/setting/anayltics',
              name: 'agglocalSettingAnayltics',
              component: AgglocalSettingAnayltics,
              meta: {
                belongName:['aggregator'],
                noEnterRoreId: ['12'],
                alias:'Agg Local Media '
              }
            },
            // {
            //   path: '/localMedia/setting',
            //   name: 'localSetting',
            //   // component: localSetting,
            //   meta: {
            //     belongName:['localMedia'],
            //     noEnterRoreId: ['12'],
            //     defaultPath: '/localMedia/dashboard',
            //     alias:'Local Media'
            //   },
            // }
          ]
        },
        {
          path: '/prolocalMedia',
          name: 'prolocalMedia',
          component: ProlocalMedia,
          redirect: '/prolocalMedia/dashboard',
          children: [
            {
              path: '/prolocalMedia/dashboard',
              name: 'prolocalDashboard',
              component: ProlocalDashboard,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/prolocalMedia/report',
              name: 'prolocalreport',
              component: ProlocalReport,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/prolocalMedia/creatives',
              name: 'prolocalCreatives',
              component: ProlocalCreatives,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/prolocalMedia/analysis',
              name: 'prolocalAnalysis',
              component: ProlocalAnalysis,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/prolocalMedia/setting/basicData',
              name: 'prolocalSettingBasicData',
              component: ProlocalSettingBasicData,
              meta: {
                belongName:['programmaticMkt'],
                noEnterRoreId: ['12'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/prolocalMedia/setting/creatives',
              name: 'prolocalSettingCreatives',
              component: ProlocalSettingCreatives,
              meta: {
                belongName:['programmaticMkt'],
                noEnterRoreId: ['12'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/prolocalMedia/setting/anayltics',
              name: 'prolocalSettingAnayltics',
              component:ProlocalSettingAnayltics,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media ',
                noEnterRoreId: ['12'],
              }
            },
            // {
            //   path: '/localMedia/setting',
            //   name: 'localSetting',
            //   // component: localSetting,
            //   meta: {
            //     belongName:['localMedia'],
            //     noEnterRoreId: ['12'],
            //     defaultPath: '/localMedia/dashboard',
            //     alias:'Local Media'
            //   },
            // }
          ]
        },
        {
          path: '/ProgrammaticRetarting',
          name: 'ProgrammaticRetarting',
          component: ProgrammaticRetarting,
          redirect: '/ProgrammaticRetarting/dashboard',
          children: [
            {
              path: '/ProgrammaticRetarting/dashboard',
              name: 'ProgrammaticRetartingDashboard',
              component: ProgrammaticRetartingDashboard,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/ProgrammaticRetarting/report',
              name: 'ProgrammaticRetartingreport',
              component: ProgrammaticRetartingReport,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/ProgrammaticRetarting/creatives',
              name: 'ProgrammaticRetartingCreatives',
              component: ProgrammaticRetartingCreatives,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/ProgrammaticRetarting/analysis',
              name: 'ProgrammaticRetartingAnalysis',
              component: ProgrammaticRetartingAnalysis,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/ProgrammaticRetarting/setting/basicData',
              name: 'ProgrammaticRetartingSettingBasicData',
              component: ProgrammaticRetartingSettingBasicData,
              meta: {
                belongName:['programmaticMkt'],
                noEnterRoreId: ['12'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/ProgrammaticRetarting/setting/creatives',
              name: 'ProgrammaticRetartingSettingCreatives',
              component: ProgrammaticRetartingSettingCreatives,
              meta: {
                belongName:['programmaticMkt'],
                noEnterRoreId: ['12'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/ProgrammaticRetarting/setting/anayltics',
              name: 'ProgrammaticRetartingSettingAnayltics',
              component:ProgrammaticRetartingSettingAnayltics,
              meta: {
                belongName:['programmaticMkt'],
                alias:'Pro Local Media ',
                noEnterRoreId: ['12'],
              }
            },
            // {
            //   path: '/localMedia/setting',
            //   name: 'localSetting',
            //   // component: localSetting,
            //   meta: {
            //     belongName:['localMedia'],
            //     noEnterRoreId: ['12'],
            //     defaultPath: '/localMedia/dashboard',
            //     alias:'Local Media'
            //   },
            // }
          ]
        },
        {
          path: '/programmaticManage',
          name: 'programmaticManage',
          component: programmaticManage,
          redirect: '/programmaticManage/dashboard',
          children: [
            {
              path: '/programmaticManage/dashboard',
              name: 'programmaticManageDashboard',
              component: programmaticManageDashboard,
              meta: {
                belongName:['programmaticMktManage'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/programmaticManage/report',
              name: 'programmaticManageReport',
              component: programmaticManageReport,
              meta: {
                belongName:['programmaticMktManage'],
                alias:'Pro Local Media'
              }
            },
            {
              path: '/programmaticManage/setting',
              name: 'programmaticManageSetting',
              component: programmaticManageSetting,
              meta: {
                belongName:['programmaticMktManage'],
                alias:'Pro Local Media'
              }
            },
          ]
        },

        {
          path: '/adnlocalMedia',
          name: 'adnlocalMedia',
          component:AdnlocalMedia,
          redirect: '/adnlocalMedia/dashboard',
          children: [
            {
              path: '/adnlocalMedia/dashboard',
              name: 'adnlocalDashboard',
              component:AdnlocalDashboard,
              meta: {
                belongName:['adnService'],
                alias:'Adn Local Media'
              }
            },
            {
              path: '/adnlocalMedia/report',
              name: 'adnlocalreport',
              component: AdnlocalReport,
              meta: {
                belongName:['adnService'],
                alias:'Adn Local Media'
              }
            },
            {
              path: '/adnlocalMedia/creatives',
              name: 'adnlocalCreatives',
              component: AdnlocalCreatives,
              meta: {
                belongName:['adnService'],
                alias:'Adn Local Media'
              }
            },
            {
              path: '/adnlocalMedia/analysis',
              name: 'adnlocalAnalysis',
              component: AdnlocalAnalysis,
              meta: {
                belongName:['adnService'],
                alias:'Adn Local Media'
              }
            },
            {
              path: '/adnlocalMedia/setting/basicData',
              name: 'adnlocalSettingBasicData',
              component: AdnlocalSettingBasicData,
              meta: {
                belongName:['adnService'],
                noEnterRoreId: ['12'],
                alias:'Adn Local Media'
              }
            },
            {
              path: '/adnlocalMedia/setting/creatives',
              name: 'adnlocalSettingCreatives',
              component: AdnlocalSettingCreatives,
              meta: {
                belongName:['adnService'],
                noEnterRoreId: ['12'],
                alias:'Adn Local Media'
              }
            },
            {
              path: '/adnlocalMedia/setting/anayltics',
              name: 'adnlocalSettingAnayltics',
              component:AdnlocalSettingAnayltics,
              meta: {
                belongName:['adnService'],
                noEnterRoreId: ['12'],
                alias:'Adn Local Media '
              }
            },
            // {
            //   path: '/localMedia/setting',
            //   name: 'localSetting',
            //   // component: localSetting,
            //   meta: {
            //     belongName:['localMedia'],
            //     noEnterRoreId: ['12'],
            //     defaultPath: '/localMedia/dashboard',
            //     alias:'Local Media'
            //   },
            // }
          ]
        },
        {
          path: '/authority',
          name: 'authority',
          component: Authority,
          // redirect: '/authority/userauth',
          children: [
            {
              path: '/authority/userauth',
              name: 'userauth',
              component: UserAuth,
              meta: {
                
                belongName:['authority'],
                alias:'authority'
              },
            },
            {
              path: '/authority/subscriptionSetting',
              name: 'subscriptionSetting',
              component: SubscriptionSetting,
              meta: {
                belongName:['authority'],
                alias:'authority'
              },
              
            },
            {
              path: '/authority/BisicSetting',
              name: 'bisicSetting',
              component: BisicSetting,
              meta: {
                belongName:['authority'],
                alias:'authority'
              },
              
            },
            {
              path: '/authority/CustomerProduct',
              name: 'customerProduct',
              component: CustomerProduct,
              meta: {
                belongName:['authority'],
                alias:'authority'
              },
              
            },
            {
              path: '/authority/CustomerAccount',
              name: 'customerAccount',
              component: CustomerAccount,
              meta: {
                belongName:['authority'],
                alias:'authority'
              },
              
            },
            {
              path: '/authority/Rdtools',
              name: 'Rdtools',
              component: {render: (e) => e("router-view")},
              redirect: '/authority/Rdtools/menuauth',
              meta: {
                belongName:['authority'],
                alias:'authority',
                noEnterRoreId: ['12'],
              },
              children: [
                {
                  path: '/authority/Rdtools/menuauth',
                  name: 'menuauth',
                  component: RdtoolsMenuauth,
                  meta: {
                    belongName:['authority'],
                    alias:'authority',
                    noEnterRoreId: ['12'],
                  },
                },
                {
                  path: '/authority/Rdtools/apiauth',
                  name: 'apiauth',
                  component: RdtoolsApiauth,
                  meta: {
                    belongName:['authority'],
                    alias:'authority',
                    noEnterRoreId: ['12'],
                  },
                },
              ],
            },
            {
              path: '/authority/publicsource',
              name: 'publicsource',
              redirect: '/authority/publicsource/mediasource',
              component: {render: (e) => e("router-view")},
              meta: {
                belongName:['authority'],
                alias:'authority',
         
              },
              children: [
                {
                  path: '/authority/publicsource/mediasource',
                  name: 'mediasource',
                  component: MediaSource,
                  meta: {
                    belongName:['authority'],
                    alias:'authority',
                    noEnterRoreId: ['12'],
                  },
                },
                {
                  path: '/authority/publicsource/publicresources',
                  name: 'publicresources',
                  component: publicReources,
                  meta: {
                    belongName:['authority'],
                    noEnterRoreId: ['12'],
                    alias:'authority'
                  },
                },
                {
                  path: '/authority/publicsource/whatsnewsetting',
                  name: 'whatsnewsetting',
                  component: whatsnewSetting,
                  meta: {
                    belongName:['authority'],
                    noEnterRoreId: ['12'],
                    alias:'authority'
                  },
                },
                {
                  path: '/authority/publicsource/whatsnewsetting2',
                  name: 'whatsnewsetting2',
                  component: whatsnewSetting2,
                  meta: {
                    belongName:['authority'],
                    noEnterRoreId: ['12'],
                    alias:'authority'
                  },
                },

                {
                  path: '/authority/publicsource/account',
                  name: 'account',
                  component: Account,
                  meta: {
                    belongName:['authority'],
                    noEnterRoreId: ['12'],
                    alias:'authority'
                  },
                },
                {
                  path: '/authority/publicsource/HelpCenterSetteing',
                  name: 'HelpCenterSetteing',
                  component: HelpCenterSetteing,
                  meta: {
                    belongName:['HelpCenterSetteing'],
                    noEnterRoreId: ['12'],
                    alias:'HelpCenterSetteing'
                  },
                },
                {
                  path: '/authority/publicsource/clientaccountsetting',
                  name: 'ClientAccountSetting',
                  component: ClientAccountSetting,
                  meta: {
                    belongName:['authority'],
                    noEnterRoreId: ['12'],
                    alias:'ClientAccountSetting'
                  },
                },
                {
                  path: '/authority/publicsource/businessauthoritysetting',
                  name: 'BusinessAuthoritySetting',
                  component: BusinessAuthoritySetting,
                  meta: {
                    belongName:['authority'],
                    noEnterRoreId: ['12'],
                    alias:'BusinessAuthoritySetting'
                  },
                }
                // {
                //   path: '/authority/publicsource/AccountAuthority',
                //   name: 'AccountAuthority',
                //   component: AccountAuthority,
                //   meta: {
                //     belongName:['AccountAuthority'],
                //     noEnterRoreId: ['12'],
                //     alias:'AccountAuthority'
                //   },
                // }
              ]
            },
          ]
        },
        {
          path: '/userhome',
          name: 'userhome',
          component: Userhome,
          children: []
        },
        {
          path: '/noAuthority',
          name: 'noAuthority',
          component: NoAuthority,
          children: []
        },
        {
          path: '/kolSearch',
          name: 'KolSearch',
          component: KolSearch,
          children: []
        },
        {
          path: '/helpCenter',
          name: 'HelpCenter',
          component: HelpCenter,
          children: []
        },
        {
          path: '/helpCenterView',
          name: 'HelpCenterView',
          component: HelpCenterView,
          children: []
        },
        {
          path:'/detailPage',
          name:'DetailPage',
          component:DetailPage
        },
        {
          path:'/tiktokDetailPage',
          name:'TiktokDetailPage',
          component:TiktokDetailPage
        },{
          path:'/insDetailPage',
          name:'InsDetailPage',
          component:InsDetailPage
        },
        ,{
          path:'/collectionPage',
          name:'CollectionPage',
          component:CollectionPage
        },{
          path:'/kolFolderPage',
          name:'KolFolderPage',
          component:KolFolderPage
        },
        
        {
          path: '/resources',
          name: 'resources',
          component: Resources,
          redirect: '/resources/marketreports',
          children: [
            {
              path: '/resources/marketreports',
              name: 'marketreports',
              component: Marketreports,
              meta: {
                // belongName:['resources'],
                alias:'resources'
              },
            },
            {
              path: '/resources/appanalysis',
              name: 'appanalysis',
              component: Appanalysis,
              meta: {
                // belongName:['resources'],
                alias:'resources'
              },
            },
            {
              path: '/resources/competitoranalysis',
              name: 'competitoranalysis',
              component: Competitoranalysis,
              meta: {
                // belongName:['resources'],
                alias:'resources'
              },
            },
            {
              path: '/resources/appDataMarket',
              name: 'appDataMarket',
              component: AppDataMarket,
              meta: {
                // belongName:['resources'],
                alias:'resources'
              },
            },
          ]
        },
        {
          path: '/appDataMarket',
          name: 'newAppDataMarket',
          component: newAppDataMarket,
          children: []
        },
        {
          path: '/marketAnalysisReports',
          name: 'marketAnalysisReports',
          component: marketAnalysisReports,
          children: []
        },
        {
          path: '/appAnalysisReports',
          name: 'appAnalysisReports',
          component: appAnalysisReports,
          children: []
        },
        {
          path: '/programmatic',
          name: 'programmatic',
          component: Programmatic,
          children: []
        },
        {
          path: '/whatsnew',
          name: 'whatsnew',
          component: Whatsnew
        },
        {
          path: '/notifications',
          name: 'notifications',
          component: Notifications,
        },
      ]
    }
  ]
})

routers.beforeEach(function (to, from, next) {
  if ((!to.meta || !to.meta.noEnterRoreId)) {
    next()
  } else {
    if (to.meta.noEnterRoreId.includes(routers.app.$options.store.state.userInfo.role_id)) {
      // message.warning('您没有进入该页面的权限,请联系管理员')
      setTimeout(() => {
        next(to.meta.defaultPath || '/noAuthority')
        // next('/noAuthority')
          // next(to.meta.defaultPath || '/noAuthority')
      })
    } else {
      next()
    }
  }
})
function redirectF(children){
  let limits=localStorage.getItem('limits')
  for(let i=0;i<children.length;i++){
      if(limits.includes(children[i].name)){
          return children[i].path
      }
  }
}


export default routers;



// WEBPACK FOOTER //
// ./src/router/index.js